// extracted by mini-css-extract-plugin
module.exports = {"uppwdWrap":"index_uppwdWrap_1zmX5"};